/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DiscordConnection } from './DiscordConnection';
import {
    DiscordConnectionFromJSON,
    DiscordConnectionFromJSONTyped,
    DiscordConnectionToJSON,
    DiscordConnectionToJSONTyped,
} from './DiscordConnection';

/**
 * 
 * @export
 * @interface DiscordInfo
 */
export interface DiscordInfo {
    /**
     * Discord user ID
     * @type {string}
     * @memberof DiscordInfo
     */
    id?: string;
    /**
     * Discord username
     * @type {string}
     * @memberof DiscordInfo
     */
    username?: string;
    /**
     * Platform accounts linked to this Discord user
     * @type {Array<DiscordConnection>}
     * @memberof DiscordInfo
     */
    connections?: Array<DiscordConnection>;
}

/**
 * Check if a given object implements the DiscordInfo interface.
 */
export function instanceOfDiscordInfo(value: object): value is DiscordInfo {
    return true;
}

export function DiscordInfoFromJSON(json: any): DiscordInfo {
    return DiscordInfoFromJSONTyped(json, false);
}

export function DiscordInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscordInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'username': json['username'] == null ? undefined : json['username'],
        'connections': json['connections'] == null ? undefined : ((json['connections'] as Array<any>).map(DiscordConnectionFromJSON)),
    };
}

export function DiscordInfoToJSON(json: any): DiscordInfo {
    return DiscordInfoToJSONTyped(json, false);
}

export function DiscordInfoToJSONTyped(value?: DiscordInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'username': value['username'],
        'connections': value['connections'] == null ? undefined : ((value['connections'] as Array<any>).map(DiscordConnectionToJSON)),
    };
}

